import { render, staticRenderFns } from "./TableFieldConfig.vue?vue&type=template&id=3123ef5d&scoped=true&"
import script from "./TableFieldConfig.vue?vue&type=script&lang=ts&"
export * from "./TableFieldConfig.vue?vue&type=script&lang=ts&"
import style0 from "./TableFieldConfig.vue?vue&type=style&index=0&id=3123ef5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123ef5d",
  null
  
)

export default component.exports